export default "__VITE_ASSET__58f6b45d__"